if (!customElements.get('minuta-scene')) {
  customElements.define('minuta-scene', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.visibilityObserver?.disconnect();
      this.abort = new AbortController();
      const options = {signal: this.abort.signal};
      this.points = Array.from(this.querySelectorAll('.mp-scene-point'));
      this.cards = Array.from(this.querySelectorAll('.mp-scene-card'));
      this.addEventListener('click', event => {
        const point = event.target.closest('.mp-scene-point');
        if (point) { if (this.active === point) this.close(true); else this.open(point); }
        else if (event.target.closest('.mp-scene-close')) this.close(true);
      }, options);
      document.addEventListener('click', event => {
        if (this.active && (!this.contains(event.target) || (!event.target.closest('.mp-scene-card') && !event.target.closest('.mp-scene-point')))) this.close(false);
      }, options);
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.active) {event.preventDefault();this.close(true);}
      }, options);
      window.addEventListener('scroll', () => this.position(), {...options, passive:true});
      this.addEventListener('shopify:block:select', event => {
        const point = event.target.closest('.mp-scene-point');
        if (point) this.open(point, false);
      }, options);
      this.observer = new ResizeObserver(() => this.position());
      this.observer.observe(this);
      this.cards.forEach(card => this.observer.observe(card));
      this.classList.add('mp-scene-ready');
      this.visibilityObserver = new IntersectionObserver(entries => {
        this.classList.toggle('mp-scene-in-view', entries[0].isIntersecting);
      });
      this.visibilityObserver.observe(this);
    }
    disconnectedCallback() {this.abort?.abort();this.observer?.disconnect();this.visibilityObserver?.disconnect();}
    close(restoreFocus) {
      const previous = this.active;
      this.cards.forEach(card => {card.hidden = true;});
      this.points.forEach(point => point.setAttribute('aria-expanded','false'));
      this.active = null;
      if (restoreFocus) previous?.focus({preventScroll:true});
    }
    open(point, focus = true) {
      const card = this.cards.find(item => item.id === point.getAttribute('aria-controls'));
      if (!card) return;
      this.close(false); this.active = point; card.hidden = false;
      point.setAttribute('aria-expanded','true'); this.position();
      if (focus) card.querySelector('.mp-scene-close').focus({preventScroll:true});
    }
    position() {
      if (!this.active) return;
      const card = this.cards.find(item => !item.hidden);
      if (!card) return;
      if (matchMedia('(max-width:749px)').matches) {card.style.left='';card.style.top='';card.style.maxHeight='';return;}
      const stage = this.querySelector('.mp-scene-stage').getBoundingClientRect();
      const point = this.active.getBoundingClientRect();
      const header = document.querySelector('.section-header-sticky .header, .section-header-sticky-always .header');
      const headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      const visibleTop = Math.max(12, headerBottom + 12 - stage.top);
      const visibleBottom = Math.min(stage.height - 12, innerHeight - 24 - stage.top);
      const fitsViewport = visibleBottom - visibleTop >= 200;
      const topLimit = fitsViewport ? visibleTop : 12;
      const bottomLimit = fitsViewport ? visibleBottom : stage.height - 12;
      card.style.maxHeight = `${Math.max(200, Math.min(bottomLimit - topLimit, innerHeight - 100))}px`;
      const width = card.offsetWidth, height = card.offsetHeight;
      const x = point.left - stage.left + point.width / 2;
      const y = point.top - stage.top + point.height / 2;
      const preferred = x + 30 + width <= stage.width - 12 ? x + 30 : x - width - 30;
      card.style.left = `${Math.max(12,Math.min(stage.width-width-12,preferred))}px`;
      card.style.top = `${Math.max(topLimit,Math.min(bottomLimit-height,y-height/2))}px`;
    }
  });
}
